import React, { Component } from 'react';

import classes from './OrderTotal.css';

class OrderTotal extends Component {

    formatCurrency(value) {
        if (!value || value == '') {
          return '$0.00';
        }
        else {
          return '$' + parseFloat(value).toFixed(2);
        }
      }
      
      render() {
          return (
    <div className={classes.OrderTotal}>
    <p> # Bags: {this.props.totalBags} Total Price: <strong>{this.formatCurrency(this.props.total)}</strong></p>
    </div>
          );
      }
}
export default OrderTotal;


// WEBPACK FOOTER //
// ./src/components/Order/OrderTotal/OrderTotal.js